import React from 'react'

export interface IWorkplaceQuizRowProps {
  title: string
  id: number
  startQuiz: (id: number) => void
}

const WorkplaceQuizModuleMenuRow = (props: IWorkplaceQuizRowProps) => {
  const navigate = () => {
    if (props.id === null || props.id === undefined || props.id < 0) {
      return
    }
    props.startQuiz(props.id)
  }

  return (
    <>
      <button
        onClick={navigate}
        tabIndex={0}
        onKeyUp={(event) => {
          if (event?.keyCode == '13') {
            navigate()
          }
        }}
      >
        {props.title}
      </button>
    </>
  )
}

export default WorkplaceQuizModuleMenuRow
